import { render, staticRenderFns } from "./SspEmptyCard.vue?vue&type=template&id=68687e18&scoped=true&lang=pug"
import script from "./SspEmptyCard.vue?vue&type=script&lang=js"
export * from "./SspEmptyCard.vue?vue&type=script&lang=js"
import style0 from "./SspEmptyCard.vue?vue&type=style&index=0&id=68687e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68687e18",
  null
  
)

export default component.exports